<template>
    <v-sheet>
        <v-row class="mt-5 align-baseline">
            <v-col class="title ml-3">관리자 변경 이력</v-col>
            <v-col class="text-right">
            </v-col>
        </v-row>
        <v-card flat class="rounded-xl">
            <v-card-text>
                <div style="position: relative;">
                    <div style="position: sticky; top: 0; z-index: 10; background: #F4F6F8; border-bottom: 1px solid #e0e0e0;">
                        <v-row no-gutters style="height: 60px; align-items: center; font-weight: 600; color: #333333;">
                            <v-col class="text-center text-h6" style="border-right: 1px solid #e0e0e0;">변경일시</v-col>
                            <v-col class="text-center text-h6" style="border-right: 1px solid #e0e0e0;">작업자</v-col>
                            <v-col class="text-center text-h6" style="border-right: 1px solid #e0e0e0;">대상자</v-col>
                            <v-col class="text-center text-h6">내용</v-col>
                        </v-row>
                    </div>
                    <div ref="scrollContainer" style="max-height: 680px; overflow-y: auto; border: 1px solid #e0e0e0; border-top: none;">
                        <div v-for="(histItem, histIdx) in adminHistoryList" :key="'admin_hist_' + histIdx" style="border-bottom: 1px solid #f0f0f0;">
                            <v-row no-gutters style="height: 68px; align-items: center; color: #333333;">
                                <v-col class="text-center text-h6" style="border-right: 1px solid #f0f0f0;">{{ histItem.reg_dt | dateMin }}</v-col>
                                <v-col class="text-center text-h6" style="border-right: 1px solid #f0f0f0;">{{ histItem.action_admin_user_name }}</v-col>
                                <v-col class="text-center text-h6" style="border-right: 1px solid #f0f0f0;">{{ histItem.target_admin_user_name }}</v-col>
                                <v-col class="text-center text-h6">{{ histItem.action_desc }}</v-col>
                            </v-row>
                        </div>
                    </div>
                </div>
                <v-row v-if="hasMore" class="mt-3">
                    <v-col class="text-center">
                        <v-btn
                            color="#4573D5"
                            @click="loadMore"
                            :loading="loading"
                            :disabled="loading"
                            x-large
                            rounded
                            class="white--text"
                            style="min-width: 160px; height: 50px; font-size: 16px; font-weight: 500;"
                        >
                            <v-icon left>mdi-chevron-down</v-icon>
                            더 보기
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-sheet>
</template>
<script>
import {mapGetters} from 'vuex'

export default {
    name: 'admin_log_list',
    components: {},
    data: () => ({
        page_no: 1,
        page_size: 10,
        loading: false,
        hasMore: true,
        isScrolling: false
    }),
    created() {
        this.loadInitialData()
    },
    computed: {
        ...mapGetters({
            adminHistoryList: 'admin/getAdminHistoryList',
        }),
    },
    methods: {
        loadInitialData() {
            this.page_no = 1
            this.$store.dispatch('admin/getAdminHistoryList', {
                page_no: this.page_no,
                page_size: this.page_size,
                scb: (data) => {
                    this.hasMore = data.length === this.page_size
                },
                fcb: (err) => {
                    console.error('Failed to load admin history:', err)
                }
            })
        },
        loadMore() {
            if (this.loading || !this.hasMore) return
            
            this.loading = true
            this.page_no++
            
            this.$store.dispatch('admin/getAdminHistoryListMore', {
                page_no: this.page_no,
                page_size: this.page_size,
                scb: (data) => {
                    this.hasMore = data.length === this.page_size
                    this.loading = false
                    this.$nextTick(() => {
                        this.scrollToBottom()
                    })
                },
                fcb: (err) => {
                    console.error('Failed to load more admin history:', err)
                    this.loading = false
                    this.page_no--
                }
            })
        },
        scrollToBottom() {
            this.isScrolling = true
            const container = this.$refs.scrollContainer
            if (container) {
                container.scrollTo({
                    top: container.scrollHeight,
                    behavior: 'smooth'
                })
                setTimeout(() => {
                    this.isScrolling = false
                }, 1000)
            }
        },
        onScroll(event) {
            console.log('not used')
            /*if (this.isScrolling) return
            
            const { scrollTop, scrollHeight, clientHeight } = event.target
            if (scrollTop + clientHeight >= scrollHeight - 10 && this.hasMore && !this.loading) {
                this.loadMore()
            }*/
        }
    }
}
</script>

